export class ContactPropertyCodes {
    static readonly NAME = 'name';
    static readonly LAST_NAME = 'lastName';
    static readonly FIRST_NAME = 'firstName';
    static readonly EMAIL = 'email';
    static readonly COMPANY_NAME = 'companyName';
    static readonly MOBILE_NUMBER = 'mobileNumber';
}
